import { render } from "./addRemove.vue?vue&type=template&id=5cf56b58&scoped=true"
import script from "./addRemove.vue?vue&type=script&lang=js"
export * from "./addRemove.vue?vue&type=script&lang=js"

import "./addRemove.vue?vue&type=style&index=0&id=5cf56b58&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf56b58"]])

export default __exports__